const FRESHNESS_LIMIT_HOURS = 48;
const STALE_LIMIT_DAYS = 7;

function toTimestamp(value) {
  if (!value) return null;
  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
}

export function getMissionControlFreshness(lastPatientMessageAt, now = new Date()) {
  const timestamp = toTimestamp(lastPatientMessageAt);
  if (timestamp === null) return "never";

  const elapsedHours = Math.max(0, new Date(now).getTime() - timestamp) / 3_600_000;
  if (elapsedHours < FRESHNESS_LIMIT_HOURS) return "fresh";
  if (elapsedHours <= STALE_LIMIT_DAYS * 24) return "warning";
  return "stale";
}

export function formatMissionControlLastPatientMessage(lastPatientMessageAt, now = new Date()) {
  const timestamp = toTimestamp(lastPatientMessageAt);
  if (timestamp === null) return "Jamais";

  const elapsedMs = Math.max(0, new Date(now).getTime() - timestamp);
  const elapsedHours = Math.floor(elapsedMs / 3_600_000);
  if (elapsedHours < 1) return "à l'instant";
  if (elapsedHours < 24) return `il y a ${elapsedHours}h`;
  return `il y a ${Math.floor(elapsedHours / 24)}j`;
}

export function formatMissionControlBotResponseRate(rate) {
  const numericRate = Number(rate);
  if (rate === null || rate === undefined || !Number.isFinite(numericRate)) return "N/A";
  return `${Math.round(numericRate * 100)}%`;
}

function getSortValue(row, column) {
  if (column === "last_patient_message_at") return toTimestamp(row[column]) ?? 0;
  if (row[column] === null || row[column] === undefined || row[column] === "") return null;
  const numericValue = Number(row[column]);
  return Number.isFinite(numericValue) ? numericValue : null;
}

export function sortMissionControlRows(rows, column, direction) {
  const multiplier = direction === "desc" ? -1 : 1;

  return rows
    .map((row, index) => ({ row, index }))
    .sort((left, right) => {
      const leftValue = getSortValue(left.row, column);
      const rightValue = getSortValue(right.row, column);

      if (leftValue === null && rightValue === null) return left.index - right.index;
      if (leftValue === null) return 1;
      if (rightValue === null) return -1;
      if (leftValue === rightValue) return left.index - right.index;
      return (leftValue < rightValue ? -1 : 1) * multiplier;
    })
    .map(({ row }) => row);
}
